<template>
    <div class="lang-switcher">
        <q-select
            v-model="currencySelect"
            dark
            :options="currencies"
            option-value="key"
            option-label="name"
            map-options
            borderless
            :disable="cannotSelect"
            @input="changeCurrency(currencySelect)"
        >
            <template v-slot:selected-item="scope">
                {{ scope.opt.definition ? scope.opt.definition['symbol'] : '' }}
            </template>
            <template v-slot:option="scope">
                <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
                    <q-item-section class="items-center">
                        {{
                            scope.opt.definition
                                ? scope.opt.definition['symbol']
                                : ''
                        }}
                        <q-tooltip>
                            <span class="text-capitalize">{{
                                scope.opt.name
                            }}</span>
                        </q-tooltip>
                    </q-item-section>
                </q-item>
            </template>
        </q-select>
        <q-tooltip v-if="!cannotSelect">
            <span class="">{{ $t('general.select_currency') }}</span>
        </q-tooltip>
        <q-tooltip v-if="cannotSelect">
            <span class="">{{ $t('general.cannot_select_currency') }}</span>
        </q-tooltip>
    </div>
</template>

<script>
import userConfigurationsService from '@/services/modules/userConfigurations'
import store from '@/store'

const loadingKeys = {
    fetchingCurrencies: 'fetching-currencies',
    fetchingUserConfigurations: 'fetching-user-configurations',
    savingUserConfigurations: 'saving-user-configurations',
}

export default {
    name: 'CurrencySelector',

    data() {
        return {
            currencySelect: {},
        }
    },

    computed: {
        currencies() {
            let currencies = []
            for (let index = 0; index < this.currencyList.length; index++) {
                let currency = this.currencyList[index]
                currencies.push({
                    id: currency.id,
                    key: currency.key,
                    name: currency.name,
                    definition: JSON.parse(currency.definition),
                })
            }
            return currencies
        },

        currency() {
            return store.getters['currency/currentCurrency']
        },

        currencyList() {
            return store.getters['currency/currencyList']
        },

        locale() {
            return store.getters['locale/currentLocale']
        },

        userLogged() {
            return store.getters['session/user']
        },

        isAuthenticated() {
            return store.getters['session/isAuthenticated']
        },

        cannotSelect() {
            return this.$route?.name == 'Checkout'
        },
    },

    watch: {
        currency(value) {
            this.currencySelect = value
        },
    },

    mounted() {
        this.currencySelect = this.currency
    },

    methods: {
        changeCurrency(currency) {
            this.currencySelect = currency
            store.commit('currency/setCurrency', currency)
            // if (this.isAuthenticated) {
            //     let parameters = {
            //         configurations: [
            //             {
            //                 locale: this.locale.key,
            //                 currency: currency.id,
            //             },
            //         ],
            //     }

            //     this.updateUserConfiguration(parameters)
            // }
        },

        async updateUserConfiguration(parameters) {
            this.loadingAdd(loadingKeys.savingUserConfigurations)

            let response = await userConfigurationsService.update(parameters)
            // TODO ERROR HANDLING
            if (response.status === 200) {
            } else {
            }
            this.loadingRemove(loadingKeys.savingUserConfigurations)
        },
    },
}
</script>
